<template>
  <div class="flex flex-col flex-grow">
    <Loading class="flex-grow" :loading="waitPending">
      <div class="flex-grow">
        <Table
          :columns="columns"
          :rows="orders"
          :row-style-class="() => 'cursor-pointer'"
          :busy="waitPending"
          @on-row-click="onRowClick"
          @on-sort-change="($event) => {orderBy = $event}"/>
      </div>
    </Loading>
    <div class="flex flex-row items-end justify-center p-6">
      <Pagination
        :page="page"
        :page-count="pageCount"
        @change="onPageChange"/>
    </div>
  </div>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import Attachment from '@/components/global/Attachment.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Table,
    Pagination,
    Loading,
  },
  data() {
    return {
      limit: 100,
      page: 1,
      orderBy: [],
    };
  },
  computed: {
    ...mapGetters({
      payload: 'objects/orders',
    }),
    columns() {
      return [
        {
          label: '№',
          field: 'id',
          tdClass: 'align-middle',
          cell: ({ row }) => <div class="flex flex-col items-start">
            <b>{ row.name }</b>
            <StatusBadge status={row.state}/>
            { row.isComplex && <span class="text-10px leading-12px font-bold text-primary">Комплексный</span> }
          </div>,
          sortable: true,
        },
        {
          label: 'Создан',
          field: 'createdAt',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>
            { this.$moment(row.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') }
          </b>,
          sortable: true,
        },
        {
          label: 'Заказчик',
          field: 'contractorName',
          sortable: false,
        },
        {
          label: 'Принят',
          field: ' ',
          sortable: false,
        },
        {
          label: 'Завершен',
          field: ' ',
          sortable: false,
        },
        {
          label: 'Стоимость',
          field: 'price',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>{ this.$numeral(parseFloat(row.price)).format('0,0 $') }</b>,
          sortable: true,
        },
        { label: 'Локация', field: 'regionName', sortable: true },
        { label: 'Исполнитель', field: 'contractorName', sortable: true },
        {
          label: 'Услуга',
          field: 'firstServiceCategoryId',
          cell: ({ row }) => {
            const id = _.get(row, 'firstServiceCategory.iconAttach');
            return <Attachment class="w-6 h-6 object-center object-contain" id={id}/>;
          },
          sortable: true,
        },
        {
          label: 'Рейтинг',
          field: 'rating',
          cell: ({ row }) => {
            if (row.rating !== null) {
              return <div class="flex flex-row items-center space-x-1">
                {/* eslint-disable-next-line global-require */}
                <img className="mb-1" src={require('@/assets/icons/star.svg')}/>
                <b>{ this.$numeral(parseFloat(row.rating)).format('0.0') }</b>
              </div>;
            }
            return null;
          },
          sortable: true,
        },
      ];
    },
    id() {
      return _.get(this.$route, 'params.id');
    },
    orders() {
      return _.get(this.payload(this.id), 'data') || [];
    },
    offset() {
      return (this.page - 1) * this.limit;
    },
    total() {
      return _.get(this.payload(this.id), 'total') || 0;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    waitKey() {
      return `fetch.object.orders.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'objects/ACT_FETCH_OBJECT_ORDERS',
    }),
    fetchPayload() {
      let { orderBy } = this;
      if (_.isEqual(orderBy, [])) {
        orderBy = [
          { column: 'id', descending: 1 },
        ];
      }
      this.fetch({
        id: this.id,
        limit: this.limit,
        offset: this.offset,
        orderBy,
      });
    },
    onPageChange(event) {
      this.page = event;
    },
    onRowClick({ row: event }) {
      this.$router.push({
        name: 'orders.info',
        params: {
          id: event.id,
        },
      });
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.fetchPayload();
    });
    this.$watch((that) => [that.page, that.orderBy], () => {
      this.fetchPayload();
    });
  },
};
</script>
